
export default function (props) {
  return (
    <header className="header">
      <div className="color-bg-main color-text-clear p-2">
        <h2 className="text-center p-0 m-0">{props.children}</h2>
      </div>
    </header>
  );
}